import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const PL = '/bang-luong/phieu-luong'

// Lấy lịch sử gửi payslip
export function layLichSuGiaoNhan(payslipId: number, querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${PL}/${payslipId}/lich-su-gui`, {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xác nhận payslip
export function xacNhanBangLuong(payslipId: number) {
  try {
    return axiosApi.post(`${PL}/${payslipId}/xac-nhan`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Khóa payslip
export function khoaBangLuong(payslipId: number) {
  try {
    return axiosApi.post(`${PL}/${payslipId}/khoa`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
